<ng-container *ngIf="_engine">
    <ng-container *ngFor="let templateGroup of topGroups; index as index">
        <ng-container *ngIf="index !== 0"> <div class="margin-top hide-in-print"></div> </ng-container>
        <adjustments-reclasses-group-form-component
            [language]="language"
            [engine]="_engine"
            (copiedBalanceChangeInAdjustmentsToIncomeAdjustment)="
                copyBalanceChangeInAdjustmentToIncomeAdjustment($event)
            "
            [templateGroup]="templateGroup"
            [currency]="currency"
            [wordBeforeCurrency]="(wordBeforeCurrencyKey | i18next ) || wordBeforeCurrencyKey"
            [totalWord]="(totalWordKey | i18next ) || totalWordKey"
            [numberFormat]="numberFormat"
            [shouldRecalculate]="shouldRecalculate"
            [readonlyReclasses]="readonlyReclasses"
            [templateRowIdToRowChildrenIds]="templateRowIdToRowChildrenIds"
            [templateRowIdToParentsIds]="templateRowIdToParentsIds"
        >
        </adjustments-reclasses-group-form-component>
    </ng-container>
</ng-container>
